import React from "react";
import PropTypes from "prop-types";
import { Card, Typography } from "antd";
import moment from "moment";
const { Paragraph } = Typography;

class CreditAppraisalDateOfAppointment extends React.Component {
    onChange = value => {
        this.value = moment(value).format("YYYY-MM-DD");
        if(this.value === this.props.dateOfAppointment) {
            return;
        }
        this.props.update(this.value);
    };
    render() {
        if (!this.value) {
            this.value = this.props.dateOfAppointment;
        }
        return (
            <Card className={"small-card-title"} title={"Date of Appointment with Anchor"}>
                <Paragraph
                    editable={(!this.props.isRiskApprover && this.props.isUserAllowedToEdit) && !this.props.recreditViewOnlyPermission ? {
                        onChange: this.onChange
                    } : false}
                    className={"d-flex justify-content-space-between"}
                    level={4}
                >
                    {this.value ? moment(this.value).format("DD MMM YYYY") : "--"}
                </Paragraph>
            </Card>
        );
    }
}

CreditAppraisalDateOfAppointment.propTypes = {
    dateOfAppointment: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    update: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default CreditAppraisalDateOfAppointment;
